$bog_music_account $mol_view
	font_size? \normal
	dev? false
	sub /
		<= Font_row $mol_view
			sub /
				<= Font_label $mol_view
					sub / \Размер шрифта
				<= Font_size $mol_switch
					value? <=> font_size?
					options *
						normal \Обычный
						large \Крупный
						huge \Огромный
		<= Dev $mol_check_box
			title @ \Включить дев мод
			checked? <=> dev?
		<= Sync_row $mol_view
			sub /
				<= Download_playlist $mol_button_minor
					hint @ \Упаковать файлы видимого плейлиста с этого устройства в zip
					click? <=> download_playlist? null
					sub /
						<= Download_playlist_icon $mol_icon_download
						<= Download_playlist_label $mol_view sub / \Скачать плейлист zip-архивом
				<= Download_playlist_status $mol_view sub / <= download_playlist_status \
		<= Cards $mol_view
			sub /
				<= Profile $mol_view
					sub /
						<= Nickname_field $mol_form_field
							name \Имя
							Content <= Nickname_input $mol_string
								value? <=> nickname? \
								hint \Как тебя зовут?
						<= Lord $mol_view
							sub /
								\ЛК:
								<= Lord_text $mol_view sub / <= lord_text \
				<= Telegram $mol_view
					sub /
						<= Tg_title $mol_paragraph
							title \Музыка из Телеграма
						<= Tg_hint $mol_paragraph
							title <= tg_hint \
						<= Tg_connect $mol_button_minor
							title <= tg_button \
							click? <=> tg_link? null
						<= Tg_status $mol_view sub / <= tg_status \
				<= Lastfm $mol_view
					sub /
						<= Fm_title $mol_paragraph
							title \Last.fm
						<= Fm_hint $mol_paragraph
							title <= fm_hint \
						<= Fm_connect $mol_button_minor
							title <= fm_button \
							click? <=> fm_link? null
						<= Fm_status $mol_view sub / <= fm_status \
				<= Export $mol_view
					sub /
						<= Warning $mol_paragraph
							title \Ссылка ниже — СЕКРЕТ. Не делись ей публично.
						<= Copy $mol_button_minor
							title \Скопировать ссылку для переноса
							click? <=> copy? null
						<= Copy_status $mol_view sub / <= copy_status \
						<= Qr_show $mol_check
							title @ \Показать QR для переноса
							checked? <=> qr_showed? false
						<= Qr $bog_qr
							uri <= account_link \
							error_correction \L
							gradient_stops /
								\#111827
								\#1e3a8a
				<= Import $mol_view
					sub /
						<= Import_hint $mol_paragraph
							title \Перенести с другого устройства — вставь ссылку:
						<= Import_input $mol_string
							hint \https://.../music/#account=...
							value? <=> import_link? \
						<= Import_apply $mol_button_minor
							title \Применить
							click? <=> apply_import? null
						<= Import_scan $bog_music_qrscan
							prefix \#account=
							found? <=> qr_found? \
						<= Import_status $mol_view sub / <= import_status \
				<= Reset $mol_view
					sub /
						<= Reset_hint $mol_paragraph
							title \Сбросить состояние и сгенерировать новый аккаунт. Текущие треки в Giper Baza останутся orphan.
						<= Reset_button $mol_button_minor
							title \Сбросить локальный аккаунт
							click? <=> reset_account? null
